export default "__VITE_ASSET__BbDN1F5O__"